import { inject, Injectable } from '@angular/core';
import { CtBatch } from '@ps-gui/claims-terminal-shared';

import { Ct2ConfigService } from '../ct2-config.service';

@Injectable({ providedIn: 'root' })
export class CtBatchRedirectStoreService {
  private readonly configService = inject(Ct2ConfigService);
  private readonly redirectUrlByCtBatchId = new Map<string, string>();

  setAuditRedirectUrl(batchId: string, auditId: string) {
    this.redirectUrlByCtBatchId.set(batchId, this.buildAuditRedirectUrl(auditId));
  }

  buildAuditRedirectUrl(auditId: string): string {
    return `${this.configService.config.auditUrl}/audit/${auditId}`;
  }

  setDigideskRedirectUrl(batchId: string, taskId: string) {
    this.redirectUrlByCtBatchId.set(
      batchId,
      `${this.configService.config.digideskUrl}/task?taskId=${taskId}`,
    );
  }

  getRedirectUrl(ctBatch: CtBatch): string {
    return this.redirectUrlByCtBatchId.get(ctBatch.id)!;
  }
}
